export const projectContainerCompanyKeys = {
  root: () => ['projectContainerCompany'] as const,
  all: (projectContainerId: number | undefined) => ['projectContainerCompany', projectContainerId] as const,
  overview: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'overview'] as const,
  assessmentContext: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'assessmentContext'] as const,
  policies: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'policies'] as const,
  contacts: (projectContainerId: number | undefined) =>
    ['projectContainerCompany', projectContainerId, 'contacts'] as const
};
